module.exports = __webpack_public_path__ + "static/media/3d-plan_general OrthoStudio V5.56f0c372.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/3d-plan_general OrthoStudio V5.svg
// module id = 939
// module chunks = 0